import { HTTP_STATUS } from '@wareclouds/frontend-common';
import axios from 'axios';

const ONBOARDING_TOKEN_KEY = 'onboarding_token';

export const ONBOARDING_LEAD_UNAUTHORIZED_EVENT =
  'onboarding-lead-unauthorized';

class LeadRequestError extends Error {
  constructor(message, data, originalError) {
    super(message);
    this.name = 'LeadRequestError';
    this.data = data;
    this.originalError = originalError;
  }
}

export function createLeadInstance(baseURL) {
  const instance = axios.create({
    baseURL,
    timeout: 60000,
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(ONBOARDING_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  instance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      const status = error.response?.status;
      if (
        status === HTTP_STATUS.UNAUTHORIZED &&
        typeof window !== 'undefined'
      ) {
        window.dispatchEvent(
          new CustomEvent(ONBOARDING_LEAD_UNAUTHORIZED_EVENT)
        );
      }
      throw new LeadRequestError(
        error.message || error.name,
        error.response,
        error
      );
    }
  );

  return instance;
}

export const LEAD_ALREADY_COMPLETED_MESSAGE = 'LEAD_ALREADY_COMPLETED';

export const USER_ALREADY_EXISTS_MESSAGE = 'USER_ALREADY_EXISTS';

export const LEAD_EMAIL_EXISTS_MESSAGE = 'LEAD_EMAIL_EXISTS';

/** 400 con fallo genérico del servidor al crear lead (p. ej. BR). */
export const INTERNAL_SERVER_ERROR_MESSAGE = 'INTERNAL_SERVER_ERROR';

export function isLeadRequestUnauthorized(error) {
  return (
    error?.name === 'LeadRequestError' &&
    error?.data?.status === HTTP_STATUS.UNAUTHORIZED
  );
}

const CREATE_LEAD_EXISTING_ACCOUNT_MESSAGES = new Set([
  LEAD_ALREADY_COMPLETED_MESSAGE,
  USER_ALREADY_EXISTS_MESSAGE,
]);

export function isLeadAlreadyCompletedError(error) {
  const body = error?.data?.data;
  return (
    error?.name === 'LeadRequestError' &&
    error?.data?.status === HTTP_STATUS.BAD_REQUEST &&
    CREATE_LEAD_EXISTING_ACCOUNT_MESSAGES.has(body?.message)
  );
}

export function isLeadEmailExistsError(error) {
  const body = error?.data?.data;
  return (
    error?.name === 'LeadRequestError' &&
    error?.data?.status === HTTP_STATUS.BAD_REQUEST &&
    body?.message === LEAD_EMAIL_EXISTS_MESSAGE
  );
}

export function isCreateLeadInternalServerError(error) {
  const body = error?.data?.data;
  return (
    error?.name === 'LeadRequestError' &&
    error?.data?.status === HTTP_STATUS.BAD_REQUEST &&
    body?.message === INTERNAL_SERVER_ERROR_MESSAGE
  );
}
